// Modal.tsx
import React, { useEffect, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements, useStripe } from "@stripe/react-stripe-js";
import { auth } from "../../../../firebase/firebase";
import { useNavigate } from "react-router-dom";
import { BASE_API_URL, STRIPE_PUBLIC_KEY } from "../../../../config";
interface ModalProps {
  isOpen: boolean;
  verificationDone: () => void;
}

const stripePromise = loadStripe(STRIPE_PUBLIC_KEY);

const VerifyModal = ({ isOpen, verificationDone }: ModalProps) => {
  const [clientSecret, setClientSecret] = useState<string | null>(null);
  const [verificationUrl, setVerificationUrl] = useState<string | undefined>(undefined);
  const userId = auth.currentUser?.uid;
  const navigate = useNavigate();

  useEffect(() => {
    //http://127.0.0.1:5001/skarvostore/us-central1
    //https://us-central1-skarvostore.cloudfunctions.net
    if (isOpen && userId) {
      fetch(`${BASE_API_URL}/create_verification_session`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId }),
      })
        .then(res => res.json())
        .then(data => {
          console.log(data);
          setClientSecret(data.clientSecret);
          setVerificationUrl(data.url);
          //window.location.href = `${data.url}`;
        })
        .catch(error => console.error("Error fetching verification session:", error));
    }
  }, [isOpen, userId]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center h-full bg-black bg-opacity-50 w-fill">
      <div className="items-center content-center w-[400px] p-4 mx-auto text-center bg-white rounded-lg shadow-lg h-1/2">
        {clientSecret ? (
          <>
            <IdentityVerification verificationUrl={verificationUrl} />
            {/* <h2 className="text-lg font-bold">Process Payment</h2>
          <button onClick={verificationDone} className="px-4 py-2 mt-4 text-white bg-green-500 rounded hover:bg-green-700">
            Done
          </button> */}
          </>
        ) : (
          <>Loading...</>
        )}
      </div>
    </div>
  );
};

interface IdentityProps {
  verificationUrl?: string;
}
const IdentityVerification = ({ verificationUrl }: IdentityProps) => {
  // const stripe = useStripe();

  return (
    <div className="h-full">
      {verificationUrl ? (
        <iframe src={`${verificationUrl}`} width="100%" height="100%" style={{ border: "none" }} title="Identity Verification" />
      ) : (
        <p>Loading ...</p>
      )}
    </div>
  );
};

export default VerifyModal;
